import { 
  signInWithEmailAndPassword, 
  signOut, 
  onAuthStateChanged 
} from 'firebase/auth';
import { auth } from './config';

export const loginStaff = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return { success: true, user: userCredential.user };
  } catch (error) {
    let message = 'Login failed. ';
    switch (error.code) {
      case 'auth/invalid-credential':
        message += 'Invalid email or password.';
        break;
      case 'auth/user-not-found':
        message += 'Staff account not found.';
        break;
      case 'auth/wrong-password':
        message += 'Incorrect password.';
        break;
      default:
        message += error.message;
    }
    return { success: false, error: message };
  }
};

export const logoutStaff = async () => {
  try {
    await signOut(auth);
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const getCurrentStaffEmail = () => {
  return auth.currentUser?.email || 'unknown';
};

export const onAuthStateChange = (callback) => {
  return onAuthStateChanged(auth, callback);
};